export default __webpack_public_path__ + "static/media/kitchen3-afterF-480w.dd3bb1db.avif";